import { Endpoint } from '../../types'
import {
  GetLoanOfferDocumentQueryParams,
  LoanOfferGetLoanOfferResponse,
  LoanOfferIdPathParam,
  LoanOfferMetadata,
} from './types'

export const ENDPOINT_GET_LOAN_OFFER: Endpoint<LoanOfferGetLoanOfferResponse, void, never, LoanOfferIdPathParam> = {
  path: '/loan-offer/{loanOfferId}',
  method: 'get',
}

export const ENDPOINT_GET_LOAN_OFFER_DOCUMENT: Endpoint<string, void, GetLoanOfferDocumentQueryParams> = {
  path: '/loan-offer/document',
  method: 'get',
}

export const ENDPOINT_GET_LOAN_OFFERS: Endpoint<LoanOfferMetadata[], void, never, never> = {
  path: '/loan-offer/offers',
  method: 'get',
}
